import xhr from "lib/xhr";

export const signIn = async (params) => {
  return await xhr.post(`sign_in`, params, { withoutRedirect: true });
};

export const signOut = async () => {
  return await xhr.delete(`/users/sign_out`);
};
